import { MapPin, Clock, Flower2 } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Eventos({ datos, seccion }) {
  const eventos = datos.eventos || [];
  if (eventos.length === 0) return null;

  return (
    <section className="km-seccion" aria-label={seccion.titulo}>
      <div className="km-seccion-interior">
        <EncabezadoSeccion p="km" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="km-titulo-eventos" />
        <div className="km-eventos-lista">
          {eventos.map((ev, i) => (
            <Reveal key={ev.id || i} delay={i * 0.08}>
              <article className="km-evento" data-testid={`km-evento-${ev.id || i}`}>
                <span className="km-evento-icono">
                  <Flower2 strokeWidth={1.8} />
                </span>
                <p className="km-evento-etiqueta">{ev.etiqueta}</p>
                <h3 className="km-evento-nombre">{ev.lugar}</h3>
                <p className="km-evento-detalle">
                  <Clock strokeWidth={2} />
                  <span>{ev.horario}</span>
                </p>
                <p className="km-evento-detalle">
                  <MapPin strokeWidth={2} />
                  <span>{ev.direccion}</span>
                </p>
                {ev.urlUbicacion && (
                  <a
                    className="km-boton"
                    href={ev.urlUbicacion}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`km-boton-ubicacion-${ev.id || i}`}
                  >
                    <MapPin strokeWidth={2} />
                    {ev.textoBoton || "Cómo llegar"}
                  </a>
                )}
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
